

















































































import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { UserAPI } from '@/api/backend-client'
import { RawLocation } from 'vue-router'

interface WelcomeMessage {
    prefix: string,
    affix: string,
    show: boolean,
}

@Component
export default class UserLayout extends Vue {
    @Prop({ required: true }) readonly redirect!: string
    @Ref('wobble') wobble!: HTMLDivElement
    interaction = false
    redirecting = false
    showTransition = false
    transitionStage = 1
    size = 0
    top = 0

    windowWidth = 0
    windowHeight = 0

    created() {
        if (UserAPI.isAuthenticated) {
            this.doAuthenticationRedirect()
        }
    }

    mounted() {
        this.initializeSize()
        window.addEventListener('resize', () => {
            this.initializeSize()
        })
    }

    initializeSize() {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
    }

    @Watch('windowWidth')
    @Watch('windowHeight')
    watchSize() {
        if (this.windowWidth / 2 > this.windowHeight ) {
            this.size = this.windowWidth
        } else {
            this.size = this.windowHeight * 2
        }
    }

    @Watch('size')
    watchTop() {
        if (this.windowWidth > this.windowHeight ) {
            this.top = -this.size / 4
        } else {
            this.top = -this.size / 4
        }
    }

    speedUp(event) {
        this.interaction = true
    }

    slowDown(event) {
        this.interaction = false
    }

    async authenticationRedirect() {
        this.redirecting = true

        setTimeout(() => {
            this.showTransition = true
        }, 1000)

        await this.loopTroughTransitionStagesOrRedirect()
    }

    async loopTroughTransitionStagesOrRedirect() {
        if (this.transitionStage < 2) {
            setTimeout(async () => {
                this.transitionStage++
                await this.loopTroughTransitionStagesOrRedirect()
            }, 2000)
        } else {
            setTimeout(async () => {
                this.transitionStage++
                await this.doAuthenticationRedirect()
            }, 2500)
        }
    }

    async doAuthenticationRedirect() {
        if (this.redirect.indexOf('http') === 0) {
            const url = new URL(this.redirect)

            // Check if redirect is to One or KeyFlow
            if (url.href.includes(process.env.VUE_APP_ONE_APP_BASEURL) || url.href.includes(process.env.VUE_APP_KEYFLOW_APP_BASEURL)) {
                // Check if redirect is already to One or KeyFlow authenticate route
                if (url.pathname !== '/authenticate') {
                    url.searchParams.set('redirect', url.pathname)
                    url.pathname = '/authenticate'
                }

                // Add fresh token
                url.searchParams.set('token', UserAPI.refreshToken)
            }

            window.location.href = url.toString()
        } else {
            let redirect: RawLocation = this.redirect
            if (redirect.indexOf('logout') !== -1) {
                redirect = { name: 'dashboard' }
            }

            await this.$router.push(redirect)
        }
    }

    getRandomArbitrary(min, max) {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min) + min)
    }

    get welcomeMessage(): WelcomeMessage {
        const randomIndex = this.getRandomArbitrary(0, this.welcomeMessages.length)

        return this.welcomeMessages[randomIndex]
    }

    get welcomeMessages(): WelcomeMessage[] {
        const date = new Date()
        const isMonday = date.getDay() === 1

        return [
            {
                prefix: this.$t('auth.welcome-messages.morning.prefix').toString(),
                affix: this.$t('auth.welcome-messages.morning.affix').toString(),
                show: !isMonday && date.getHours() > 0 && date.getHours() < 12,
            }, {
                prefix: this.$t('auth.welcome-messages.afternoon.prefix').toString(),
                affix: this.$t('auth.welcome-messages.afternoon.affix').toString(),
                show: !isMonday && date.getHours() >= 12 && date.getHours() < 18,
            }, {
                prefix: this.$t('auth.welcome-messages.evening.prefix').toString(),
                affix: this.$t('auth.welcome-messages.evening.affix').toString(),
                show: !isMonday && date.getHours() >= 18 && date.getHours() < 24,
            }, {
                prefix: this.$t('auth.welcome-messages.good-to-see.prefix').toString(),
                affix: this.$t('auth.welcome-messages.good-to-see.affix').toString(),
                show: !isMonday,
            }, {
                prefix: this.$t('auth.welcome-messages.lets-start.prefix').toString(),
                affix: this.$t('auth.welcome-messages.lets-start.affix').toString(),
                show: !isMonday,
            }, {
                prefix: this.$t('auth.welcome-messages.weekend.prefix').toString(),
                affix: this.$t('auth.welcome-messages.weekend.affix').toString(),
                show: isMonday,
            },
        ].filter(message => message.show)
    }

    get wobbleClasses(): object {
        return {
            'user-auth__wobble': true,
            'user-auth__wobble--scale': this.interaction,
            'user-auth__wobble--cover-screen': this.redirecting,
        }
    }

    get contentClasses(): object {
        return {
            'user-auth__content': true,
            'user-auth-content': true,
            'user-auth-content--hide': this.redirecting,
        }
    }

    get transitionClasses(): object {
        return {
            'user-auth__transition': true,
            'user-auth__transition--display': this.redirecting,
            'user-auth__transition--visible': this.showTransition,
        }
    }

    get wobbleSizeStyle(): object {
        return {
            height: this.size + 'px',
            top: this.top + 'px',
        }
    }

    get user(): User {
        return this.$root.$currentUser
    }
}
